<template>
  <div>
    <p>先生向け画面のVue app</p>
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
</style>